<template>
    <el-dialog
            title="角色权限配置"
            :close-on-click-modal="false"
            width="45%"
            :visible.sync="visible">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="菜单权限" name="1">
                <div v-loading="loading">
                    <el-checkbox class="m_b1" v-model="checkStrictly"
                                 @change="handleCheckedTreeConnect">父子级联动
                    </el-checkbox>
                    <el-tree
                            :data="menuList"
                            :props="defaultProps"
                            node-key="id"
                            ref="menuListTree"
                            show-checkbox :check-strictly="!checkStrictly">
                    </el-tree>
                </div>
            </el-tab-pane>
            <el-tab-pane label="字段权限" name="2">
                <el-row>
                    <el-col :span="10" class="seleTb">
                        <div class="minTitle">选择元数据</div>
                        <el-input size="small" clearable maxlength="50"
                                  placeholder="输入搜索内容"
                                  v-model.trim="filterField">
                        </el-input>
                        <el-tree
                                v-loading="loading"
                                style="height:400px;overflow-y: auto"
                                ref="tree"
                                :data="fieldDataList"
                                show-checkbox
                                node-key="id"
                                :check-strictly="true"
                                default-expand-all
                                :filter-node-method="filterNode"
                                :props="defaultProps2">
                        </el-tree>
                    </el-col>
                    <el-col :span="4" class="text_center seleMiddle">
                        <div>
                            <el-button size="mini" type="primary" @click="moveData('left')">添加元数据 <i
                                    class="el-icon-arrow-right"></i></el-button>
                        </div>
                        <div style="margin-top: 30px">
                            <el-button size="mini" icon="el-icon-arrow-left" @click="moveData('right')">取消元数据
                            </el-button>
                        </div>
                    </el-col>
                    <el-col :span="10" class="seleTb">
                        <div class="minTitle">已选择元数据</div>
                        <el-table
                                :data="rightDataList"
                                size="small" height="432px"
                                class="table" border
                                ref="rightTable"
                                :row-key="'id'"
                                :tree-props="{children: 'aaaaaaa',}"
                                @selection-change="rightSelection"
                        >
                            <el-table-column :reserve-selection="true" type="selection" width="50"/>
                            <el-table-column prop="basicName" label="已选择元数据名称"
                                             show-overflow-tooltip></el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane label="栏目权限" name="3">
                <el-transfer class="exportTransfer" filterable
                             ref="transfer"
                             v-model="selColumnId"
                             :titles="['选择数据', '已选数据']"
                             target-order="push"
                             :props="{key: 'id',label: 'basicDataName'}"
                             :data="columnData" v-loading="loading">
                </el-transfer>
            </el-tab-pane>
            <el-tab-pane label="数据权限" name="4">
                <el-form size="small" :model="inputForm" :inline="true" ref="inputForm">
                    <el-form-item label="当前角色可查看:" prop="type">
                        <el-select style="width: 300px" v-model="inputForm.viewType" placeholder="请选择" clearable
                                   @change="typeChange">
                            <el-option label="所有数据" value="0"></el-option>
                            <el-option label="满足下述任一筛选条件的数据" value="1"></el-option>
                            <el-option label="满足下述所有筛选条件的数据" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <div v-if="inputForm.viewType != 0">
                        <div class="m_b1" v-if="inputForm.permissions.length">筛选条件</div>
                        <div v-for="(item, index) in inputForm.permissions" :key="index">
                            <el-form-item :prop="`permissions.${index}.metadataBasicId`"
                                          :rules="[{required: true, message: '筛选的字段名不能为空', trigger: 'change'}]">
                                <el-select v-model="item.metadataBasicId" placeholder="请选择要筛选的字段名" filterable
                                           @change="archivesChange(item)">
                                    <el-option v-for="(c, i) in config" :key="i" :label="c.name"
                                               :value="c.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item :prop="`permissions.${index}.dataCondition`"
                                          :rules="[{required: true, whitespace: true, message: '筛选条件不能为空', trigger: 'change'}]"
                                          v-if="item.metadataBasicId">
                                <el-select v-model="item.dataCondition" placeholder="请选择">
                                    <el-option
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                            v-for="item in $dictUtils.getDictList('condition')">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item :prop="`permissions.${index}.dataConditionValue`"
                                          :rules="[{required: true, message: '筛选值不能为空', trigger: 'change'}]"
                                          v-if="item.dataCondition && item.dataCondition != '=null' && item.dataCondition != '!=null'">
                                <!--单行文本-->
                                <el-input v-model.trim="item.dataConditionValue" placeholder="请输入"
                                          maxlength="200"
                                          clearable></el-input>
                            </el-form-item>
                            <div class="el-icon-error pointer" @click="del(index)"></div>
                        </div>
                        <el-button type="text" class="addCondition" @click="addCondition()">+ 添加筛选条件</el-button>
                    </div>
                </el-form>
            </el-tab-pane>
        </el-tabs>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button v-if="!loading" type="primary" size="small" @click="submit()"
                       v-noMoreClick>保存
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                loading: false,
                activeName: '1',
                // 菜单权限
                menuList: [],
                menuCheckedKeys: [],
                dataRuleCheckedKeys: [],
                id: '',
                menuIds: '',
                defaultProps: {
                    label: 'name',
                    children: 'children',
                },
                checkStrictly: false,
                // 字段权限
                filterField: '',
                fieldDataList: [],
                defaultProps2: {
                    children: 'children',
                    label: 'basicName'
                },
                rightDataList: [],
                rightDataListSelect: [],
                selectData: [],
                // 栏目权限
                selColumnId: [],
                columnData: [],
                // 数据权限
                inputForm: {
                    viewType: '',
                    permissions: [],
                },
                config: [],
            }
        },
        watch: {
            filterField(val) {
                this.$refs.tree.filter(val);
            }
        },
        methods: {
            init(id) {
                this.activeName = '1'
                this.rightDataList = []
                this.selColumnId = []
                this.checkStrictly = false
                this.id = id
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.menuListTree.setCheckedKeys([])
                    this.getMenu()
                })
            },
            handleCheckedTreeConnect(val) {
                this.checkStrictly = val
            },
            handleClick() {
                switch (this.activeName) {
                    case "1":
                        this.getMenu()
                        break
                    case "2":
                        this.getField()
                        break
                    case "3":
                        this.getColumn()
                        break
                    case "4":
                        this.getData()
                        break
                }
            },
            // 获取菜单权限
            getMenu() {
                let p1 = this.$axios(this.api.user.findAllMenu, {}, 'get')
                if (this.id) {
                    this.loading = true
                    let p2 = this.$axios(this.api.user.getById, {roleId: this.id}, 'get')
                    Promise.all([p1, p2]).then((result) => {
                        this.menuList = result[0].data
                        let data = result[1]
                        if (data.status) {
                            this.loading = false
                            setTimeout(() => {
                                let menuIds = data.data.menuIds.split(',')
                                menuIds.forEach(value => {
                                    this.$refs.menuListTree.setChecked(value, true, false)
                                })
                            })
                        }
                    })
                } else {
                    Promise.all([p1]).then((result) => {
                        this.menuList = result[0].data.treeData
                        this.loading = false
                    })
                }
            },
            // 获取字段权限
            getField() {
                this.loading = true
                this.$axios(this.api.topic.selectMetadataBasicPermission, [], 'post').then(data => {
                    if (data.status) {
                        this.fieldDataList = data.data.unselected
                        this.$axios(this.api.user.sysRoleMetadataBasic, {roleId: this.id, type: '0'}).then(data => {
                            if (data && data.status) {
                                data.data.forEach(item => {
                                    this.$refs.tree.setChecked(item, true)
                                })
                                this.$nextTick(() => {
                                    this.rightDataList = this.$refs.tree.getCheckedNodes()
                                })
                            }
                        })
                    }
                    this.loading = false
                })
            },
            // 字段过滤
            filterNode(value, data) {
                if (!value) return true;
                return data.basicName.indexOf(value) !== -1;
            },
            //移动数据 left移动左边的数据 right移动右边的数据
            moveData(name) {
                if (name == 'left') {
                    this.rightDataList = this.$refs.tree.getCheckedNodes()
                } else {
                    if (this.rightDataListSelect.length == 0) {
                        this.$message.warning('请至少选择一条数据')
                        return
                    }
                    this.rightDataListSelect.forEach(item1 => {
                        this.$refs.tree.setChecked(item1.id, false)
                        this.rightDataList = this.rightDataList.filter(item2 => {
                            return item2.id != item1.id
                        })
                    })
                    this.$refs.rightTable.clearSelection()
                }
            },

            //右边表格勾选数据
            rightSelection(val) {
                this.rightDataListSelect = val
            },
            // 获取栏目权限
            getColumn() {
                this.loading = true
                this.$axios(this.api.topic.selectMetadataBasicDataPermissionList, [], 'post').then(data => {
                    if (data.status) {
                        this.columnData = data.data.unselected
                        this.$axios(this.api.user.sysRoleMetadataBasic, {roleId: this.id, type: '1'}).then(data => {
                            if (data && data.status) {
                                this.selColumnId = data.data
                            }
                        })
                    }
                    this.loading = false
                })
            },
            // 获取数据权限
            getData() {
                this.loading = true
                this.$axios(this.api.topic.selectAllAtom, {}, 'post').then(data => {
                    if (data.status) {
                        this.config = data.data
                        this.$axios(this.api.user.sysRoleMetadataDataPermissionGetById + '/' + this.id).then(data => {
                            if (data.data.length && data.status) {
                                this.inputForm.permissions = data.data
                                this.inputForm.viewType = data.data[0].viewType
                            }
                        })
                    }
                    this.loading = false
                })
            },
            typeChange() {
                this.inputForm.permissions = []
                if (this.inputForm.viewType && this.inputForm.viewType != '0') {
                    this.addCondition()
                }
            },
            // 选择字段名
            archivesChange(val) {
                this.$set(val, 'dataConditionValue', null)
            },
            // 添加筛选条件
            addCondition() {
                this.inputForm.permissions.push({
                    metadataBasicId: '',
                    dataCondition: '',
                    dataConditionValue: '',
                })
            },
            // 删除筛选条件
            del(index) {
                if (this.inputForm.permissions.length == 1) {
                    this.$message.warning('至少保留一个筛选项')
                    return
                }
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.inputForm.permissions.splice(index, 1);
                })
            },
            // 表单提交
            submit() {
                switch (this.activeName) {
                    case "1":
                        this.saveMenu()
                        break
                    case "2":
                        this.saveField(0)
                        break
                    case "3":
                        this.saveField(1)
                        break
                    case "4":
                        this.saveData()
                        break
                }
            },
            // 保存数据权限
            saveData() {
                this.$refs['inputForm'].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.$axios(this.api.user.sysRoleMetadataDataPermission, {
                            roleId: this.id,
                            ...this.inputForm
                        }, 'post').then(data => {
                            if (data.status) {
                                this.$message.success(data.msg)
                                this.visible = false
                                this.$emit('refreshDataList')
                            } else {
                                this.$message.error(data.msg)
                            }
                            this.loading = false
                        })
                    }
                })
            },
            // 保存字段、栏目权限  type: 0字段，1栏目
            saveField(type) {
                let metadataBasicId = [], metadataBasicDataId = [], delFlag = '其他'
                if (type == 0) {
                    metadataBasicDataId = []
                    metadataBasicId = this.rightDataList.map(item => {
                        return item.id
                    })
                    if (!metadataBasicId.length) {
                        delFlag = '0'
                    }
                } else {
                    metadataBasicId = []
                    metadataBasicDataId = this.selColumnId
                    if (!metadataBasicDataId.length) {
                        delFlag = '1'
                    }
                }
                this.loading = true
                this.$axios(this.api.user.sysRoleMetadataBasicSave, {
                    roleId: this.id,
                    delFlag,
                    metadataBasicId,
                    metadataBasicDataId
                }, 'post').then(data => {
                    if (data.status) {
                        this.$message.success(data.msg)
                        this.visible = false
                        this.$emit('refreshDataList')
                    } else {
                        this.$message.error(data.msg)
                    }
                    this.loading = false
                })
            },
            // 保存菜单权限
            saveMenu() {
                this.menuIds = this.$refs.menuListTree.getCheckedKeys().concat(this.$refs.menuListTree.getHalfCheckedKeys()).join(',')
                this.loading = true
                this.$axios(this.api.user.sysrolemenuSave, {
                    roleId: this.id,
                    menuIds: this.menuIds
                }, 'post').then(data => {
                    this.loading = false
                    if (data.status) {
                        this.$message.success(data.msg)
                        this.visible = false
                        this.$emit('refreshDataList')
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .seleTb {
        padding: 15px;
        border-radius: 5px;
        border: 1px solid #DCDCDC;
    }

    .minTitle {
        margin-bottom: 5px;
        font-weight: 600;
    }

    .seleMiddle {
        margin-top: 26%;
    }
</style>
